import * as BestOffersAction from '../actions/best-offers.action';
import * as BestOffersState from '../states/best-offers.state';

export class State extends BestOffersState.State { }

const initialState: BestOffersState.State = BestOffersState.initialState;

/**
 *
 *
 * @export
 * @param {*} [state=initialState]
 * @param {BestOffersAction.Actions} action
 * @returns {BestOffersState.State}
 */
export function reducer(state = initialState, action: BestOffersAction.Actions): BestOffersState.State {
	switch (action.type) {

		case BestOffersAction.ActionTypes.PUT_BEST_OFFERS:
			state = Object.assign({}, state, { best_offers: action.payload });
			return state;
		case BestOffersAction.ActionTypes.PUT_JOURNEYS:
			state = Object.assign({}, state, { journeys: action.payload });
			return state;
		case BestOffersAction.ActionTypes.PUT_BEST_OFFERS_FLIGHTS:
			state = Object.assign({}, state, { flights: action.payload });
			return state;
		case BestOffersAction.ActionTypes.PUT_BEST_OFFERS_CITY:
			state = Object.assign({}, state, { city: action.payload });
			return state;
			case BestOffersAction.ActionTypes.RESET:
				state = Object.assign({}, state, initialState);
				return state;
		
		default:
			return state;
	}
}

export const getBestOffers = (state: BestOffersState.State) => state.best_offers;
export const getJourneys = (state: BestOffersState.State) => state.journeys;
export const getFlights = (state: BestOffersState.State) => state.flights;
export const getCity = (state: BestOffersState.State) => state.city;

